// Copyright (c) 2016 Deere & Company

import PartsClaim from '@deere/cps-it.warranty-model-factory/lib/claim-part';

export const getUpdatedPartsClaim = (currentClaim, selectedAction) =>
    PartsClaim.update(currentClaim, {
        selectedAction: {
            $set: selectedAction
        }
    });



// WEBPACK FOOTER //
// ./src/claim/parts/services/update-parts-claim.js